import {Skeleton} from '@travel-frontend/ui-components';

import {HotelBoxGallery} from '@/components/HotelBoxGallery';
import {HotelBoxInfo} from '@/components/HotelBoxInfo';
import {HotelBoxTile} from '@/components/HotelBoxTile';

type Props = {
  small?: boolean;
};

export const HotelBoxPlaceholderOld = ({small = false}: Props) => {
  return (
    <HotelBoxTile small={small}>
      <HotelBoxGallery
        images={[]}
        small={small}
        fallbackImage={<Skeleton variant="rect" height="100%" width="100%" />}
        score={0}
        scoreDescription=""
        reviewCount={0}
      />
      <HotelBoxInfo
        categoryType="unverified"
        infoTrip={
          <>
            <Skeleton variant="text" width="100px" height="1rem" />
            <Skeleton variant="text" width="150px" height="1rem" />
            <Skeleton variant="text" width="120px" height="1rem" />
          </>
        }
        category={<Skeleton variant="rect" height="1rem" width="100px" />}
        title={<Skeleton variant="text" width="70%" height="2.25rem" />}
        subtitle={<Skeleton variant="text" width="60%" height="1.5rem" />}
        cta={
          <Skeleton
            variant="rect"
            height="32px"
            width="100%"
            minWidth="160px"
          />
        }
        detailsLink={<Skeleton variant="text" width="80px" height="2rem" />}
        price={<Skeleton variant="text" width="80px" height="2rem" />}
        promotionBadges={
          <>
            <Skeleton variant="text" width="85px" height="1.5rem" />
            <Skeleton variant="text" width="75px" height="1.5rem" />
          </>
        }
        favoriteElement={<Skeleton variant="rect" width="24px" height="24px" />}
      />
    </HotelBoxTile>
  );
};
